module.exports = __webpack_public_path__ + "img/Trophy Cup Table30.b3e5fae0.jpg";